import { render, staticRenderFns } from "./AppSwitchForm.vue?vue&type=template&id=244ea16e&scoped=true&"
import script from "./AppSwitchForm.vue?vue&type=script&lang=ts&"
export * from "./AppSwitchForm.vue?vue&type=script&lang=ts&"
import style0 from "./AppSwitchForm.vue?vue&type=style&index=0&id=244ea16e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244ea16e",
  null
  
)

export default component.exports